import {
  Lock, Radar, Route, ShieldAlert, Network, Cpu, Shield, ShieldCheck,
  GraduationCap, Landmark, Scale, Vote, Wheat, Fuel, FlaskConical, TrainFront,
  Boxes, Building2, MapPin, Truck, Anchor, PackageCheck, Factory, Globe,
  Zap, Activity, Layers, Satellite, Server, Lightbulb, AlertTriangle, Phone,
} from "lucide-react";

const MAP = {
  Lock, Radar, Route, ShieldAlert, Network, Cpu, Shield, ShieldCheck,
  GraduationCap, Landmark, Scale, Vote, Wheat, Fuel, FlaskConical, TrainFront,
  Boxes, Building2, MapPin, Truck, Anchor, PackageCheck, Factory, Globe,
  Zap, Activity, Layers, Satellite, Server, Lightbulb, AlertTriangle, Phone,
};

export const ICON_NAMES = Object.keys(MAP);

export function DynIcon({ name, ...props }) {
  const Cmp = MAP[name] || Shield;
  return <Cmp {...props} />;
}
